import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Narrow closing trust statement with an optional understated CTA.
export function TrustStatement({ heading, copy, ctaLabel, ctaTo }) {
  return (
    <section className="container-dbrf py-16 lg:py-24" data-testid="trust-statement">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="font-display font-bold text-navy" style={{ fontSize: "clamp(1.6rem,2.6vw,2.4rem)" }}>{heading}</h2>
        <p className="mt-5 text-[var(--mineral)]" style={{ fontSize: "1.05rem", lineHeight: 1.7 }}>{copy}</p>
        {ctaTo && (
          <Link to={ctaTo} data-testid="trust-cta" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[var(--cobalt)] link-underline">
            {ctaLabel} <ArrowRight size={16} />
          </Link>
        )}
      </div>
    </section>
  );
}
